import { Lightning } from '@lightningjs/sdk';
import { HoverableComponent } from 'components/common/HoverableComponent';
import LoginQrCode from './LoginQrCode';
import { translate } from 'support/translate';
import TextLabel from 'components/common/TextLabel';

export interface QrCodeSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Heading: typeof TextLabel;
  Content: {
    Instructions: typeof TextLabel;
    QrCode: typeof LoginQrCode;
    Url: typeof TextLabel;
  };
}

const WIDTH = 684;
const HEIGHT = 522;

const HEADING_FONT_SIZE = 36;
const BODY_FONT_SIZE = 24;

const QR_CODE_SIZE = 208;

export default class QrCodeSection extends HoverableComponent<QrCodeSectionTemplateSpec> {
  private _Content = this.getByRef('Content')!;
  private _QrCode = this._Content.getByRef('QrCode')!;
  private _Url = this._Content.getByRef('Url')!;

  static override _template(): Lightning.Component.Template<QrCodeSectionTemplateSpec> {
    return {
      w: WIDTH,
      h: HEIGHT,
      flex: {
        direction: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      Heading: {
        type: TextLabel,
        w: WIDTH,
        text: {
          text: translate('account.qrcode.heading'),
          textAlign: 'center',
          fontSize: HEADING_FONT_SIZE,
          fontStyle: 'italic bold',
        },
      },
      Content: {
        h: 380,
        flex: {
          direction: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        Instructions: {
          type: TextLabel,
          text: {
            text: translate('account.qrcode.instructions'),
            fontSize: BODY_FONT_SIZE,
          },
        },
        QrCode: {
          type: LoginQrCode,
          size: QR_CODE_SIZE,
        },
        Url: {
          type: TextLabel,
          w: WIDTH,
          // TODO: reimplement QR URL when URL shortening is implemented
          // We can keep this component as a placeholder to center the QR in the flex
          // text: {
          //   fontSize: BODY_FONT_SIZE,
          //   fontFace: getFontFaceFromStyle('bold'),
          // },
        },
      },
    };
  }

  // override _setup() {
  //   super._setup();
  // this._QrCode.onQrCodeChanged = value => {
  // this._Url.patch({ text: { text: value } });
  // };
  // }
}
